import { closeTopModal, back, route } from './state/nav';
import { launch } from './state/play';
import { phase } from './state/session';
import { chatOpen } from './state/store';

/**
 * One step "back" in the menus (Escape key, Android back button): close the top modal, then the chat
 * drawer, then pop the screen stack. Returns false when there is nothing left to close (lobby root,
 * onboarding) or a match is running (the match handles its own pause menu).
 */
export function navigateBack(): boolean {
  if (launch.value) return false;
  if (closeTopModal()) return true;
  if (chatOpen.value) {
    chatOpen.value = false;
    return true;
  }
  if (phase.value === 'main' && route.value.screen !== 'lobby') {
    back();
    return true;
  }
  return false;
}
